import React from 'react';
import {FormattedMessage} from 'react-intl';

import messages from './messages';

/**
 * Returns a formatted message component based on the given products, quantity, and informed status.
 *
 * @param {Array} products - The list of products.
 * @param {number} quantity - The quantity of products.
 * @param {boolean} isInformed - The informed status.
 * @returns {ReactElement|null} The formatted message component or null.
 */
export const getMessage = (products, quantity, isInformed) => {
  const isRange = products.length > 1;
  const ticketsInListing = products.length;
  if (isRange) {
    if (isInformed) {
      if (quantity === 1) {
        return <FormattedMessage {...messages.rangeInformedOne} />;
      }
      if (quantity < ticketsInListing) {
        return <FormattedMessage {...messages.rangeInformedBetween} values={{quantity}} />;
      }

      return <FormattedMessage {...messages.rangeInformedAll} values={{quantity}} />;
    }

    return <FormattedMessage {...messages.rangeNotInformed} values={{quantity}} />;
  }
  if (!isInformed) {
    return <FormattedMessage {...messages.singleNotInformed} />;
  }

  return null;
};

/**
 * Determines if the products array contains a general admission section.
 *
 * @param {Array} products - The list of products.
 * @returns {boolean} True if the first product in the array has a general admission (ga) property set to true, otherwise false.
 */
export const isGeneralAdmissionSection = (products) => {
  if (Array.isArray(products) && products.length) {
    return products[0].ga || false;
  }

  return false;
};
